import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type Input = ApiDefinition['/creators/{creatorId}/team-member/{teamMemberId}']['PUT']['params'] &
  ApiDefinition['/creators/{creatorId}/team-member/{teamMemberId}']['PUT']['body'];

const updateCreatorTeamMember = async ({
  creatorId,
  teamMemberId,
  role,
  defaultWorkflowRoleId,
}: Input): Promise<void> => {
  await noodleApiClient.put(`/creators/${creatorId}/team-member/${teamMemberId}`, { defaultWorkflowRoleId, role });
};

export default updateCreatorTeamMember;
